import { useQuery } from "@tanstack/react-query"

import { getEmailEnrichment } from "~/api/priorities"
import { checkEmailConnection, getSentEmails, getUser } from "~/api/user"
import useGlobalStore from "~/store/global"
import { EmailListType } from "~/types/engage"
import { ITokenInfo } from "~/types/global"

export function useGetUser(tokenInfo: ITokenInfo, mounted: boolean) {
  const setTokenInfo = useGlobalStore((store) => store.setTokenInfo)
  return useQuery({
    queryKey: ["user-info"],
    queryFn: async () => {
      setTokenInfo(tokenInfo)
      const res = await getUser(tokenInfo as ITokenInfo)
      return res.data
    },
    enabled: !!tokenInfo && mounted
  })
}

export function useCheckEmailConnection() {
  const tenantType = useGlobalStore((store) => store.tenant?.tenant_type)
  const isOSLite = tenantType?.includes("os_lite")
  const tokenInfo = useGlobalStore((store) => store.tokenInfo)
  return useQuery({
    queryKey: ["check-email-connection"],
    queryFn: async () => {
      const res = await checkEmailConnection(tokenInfo as ITokenInfo)
      return res.data
    },
    enabled: !!tokenInfo && !isOSLite,
    retry: 1
  })
}

export function useGetSentEmails(type = EmailListType.PLATFORM) {
  const tokenInfo = useGlobalStore((store) => store.tokenInfo)
  return useQuery({
    queryKey: ["sent-emails", type],
    queryFn: async () => {
      const res = await getSentEmails(tokenInfo as ITokenInfo, type)
      return res.data
    },
    enabled: !!tokenInfo
  })
}

export function useGetEnrichEmailAddress(
  linkedin_url: string,
  enabled: boolean
) {
  const tokenInfo = useGlobalStore((store) => store.tokenInfo)
  return useQuery({
    queryKey: ["get-email", linkedin_url],
    queryFn: async () => {
      const res = await getEmailEnrichment({
        tokenInfo: tokenInfo!,
        linkedin_url
      })
      return res.data
    },
    enabled: !!(tokenInfo && linkedin_url && enabled)
  })
}
